import { IconBase, type IconProps } from './iconBase';

import type { JSX } from 'react';

export const TextMessage = ({ type, ...rest }: IconProps): JSX.Element => (
  <IconBase viewBox='0 0 24 24' {...rest}>
    {type === 'stroke' ? (
      <path
        d='M17 14h2.002a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2h-10a2 2 0 0 0-2 2v2m8 0h-10a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h1v2.5l4.5-2.5h4.5a2 2 0 0 0 2-2v-6a2 2 0 0 0-2-2'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    ) : (
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M9.002 3.25A2.75 2.75 0 0 0 6.252 6v1.25h-1.25A2.75 2.75 0 0 0 2.252 10v6a2.75 2.75 0 0 0 2.75 2.75h.25v1.75a.75.75 0 0 0 1.114.656l4.33-2.406h4.306a2.75 2.75 0 0 0 2.75-2.75v-1.25h1.25a2.75 2.75 0 0 0 2.75-2.75V6a2.75 2.75 0 0 0-2.75-2.75zm8.75 6.75v3.25h1.25c.69 0 1.25-.56 1.25-1.25V6c0-.69-.56-1.25-1.25-1.25h-10c-.69 0-1.25.56-1.25 1.25v1.25h7.25a2.75 2.75 0 0 1 2.75 2.75'
        fill='currentColor'
      />
    )}
  </IconBase>
);
